import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKgCardTypeOther = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 2,
		children: [
			/* @__PURE__ */ _jsx("circle", {
				cx: 12,
				cy: 13,
				r: 2
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 3,
				cy: 13,
				r: 2
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 21,
				cy: 13,
				r: 2
			})
		]
	})
});
export default SvgKgCardTypeOther;
